<div class="rounded-md bg-gray-50 p-8">
  <h6 class="mb-8 uppercase">Podsumowanie zamówienia</h6>

  <div class="flex items-center gap-1">
    <div class="flex-1 font-light text-gray-500">Wartość koszyka</div>
    <div class="font-bold text-gray-600">
      <app-currency [amount]="totalItemsPrice()" />
    </div>
  </div>

  <p-divider appPrimengDivider />

  <div class="flex items-center gap-1">
    <div class="flex-1 font-light text-gray-500">Dostawa</div>
    <div class="flex flex-col items-end justify-center font-bold text-gray-600">
      <div class="inline-flex justify-end gap-1">
        @if (isPredictablePriceType()) {
          <span>od</span>
        }

        <div class="flex flex-col items-end">
          <app-currency [amount]="shippingPrice()" />
        </div>

        <span
          (click)="handleShippingClick()"
          role="button">
          <app-icon [icon]="Icon.QuestionCircle" />
        </span>
      </div>

      @if (shouldShowSelectedShippingMethod()) {
        <div class="flex justify-end text-sm">
          {{ selectedShippingMethod() }}
        </div>
      }

      @if (details().shipping.quantity > 1) {
        <div class="w-3/4">
          <p-divider
            appPrimengDivider
            class="my-2 w-3/4" />

          <app-public-order-summary-additional-shipping-cost-info
            [quantity]="details().shipping.quantity"
            [unitPrice]="details().shipping.unitPrice" />
        </div>
      }
    </div>
  </div>

  @let description = selectedShippingMethodDescription();

  @if (isNotNil(description)) {
    <div class="mt-1 flex justify-end text-xs">
      <app-summernote-html-preview [html]="description" />
    </div>
  }

  <p-divider appPrimengDivider />

  @let discountData = discount();

  @if (isNotNil(discountData)) {
    <div class="flex items-center gap-1">
      <div class="flex-1 font-light text-gray-500">
        Rabat ({{ discountData.description }})
      </div>
      <div class="flex gap-1 font-bold text-gray-600">
        <span>-</span>
        <app-currency [amount]="discountData.discount" />
      </div>
    </div>

    <p-divider appPrimengDivider />
  }

  <div class="flex items-center gap-1 font-bold">
    <div class="flex-1 text-gray-500">Łącznie do zapłaty (z VAT)</div>
    <div class="text-xl">
      <app-currency [amount]="totalPrice()" />
    </div>
  </div>

  @if (recursive().length > 0) {
    <p-divider appPrimengDivider />

    <app-public-order-summary-recursive-info [recursive]="recursive()" />
  }

  <div class="mt-5">
    <p-button
      (onClick)="handleCheckoutClick()"
      [fluid]="true"
      appPrimengButton
      label="Dostawa i płatność" />
  </div>
</div>

<p-dialog
  [(visible)]="shippingTypesVisible"
  appPrimengDialog
  header="Metody realizacji dostawy">
  <app-public-shipping-methods />
</p-dialog>
